export default {
  "content": "<path d=\"M18.681 4c.584.96.847 1.95.847 3.2 0 3.986-3.415 9.164-6.187 12.8h-6.33L4.472 4.873l5.543-.525 1.342 10.764c1.255-2.036 2.802-5.235 2.802-7.417 0-1.194-.205-2.007-.526-2.677L18.681 4z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};